import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';
import { useSearchParams } from 'react-router-dom';
import { decodeSearchParams } from '@pages/CaseDashboard/utils';
import { UserManagementFilters, UsersManagementContextProps } from './types';

const UsersManagementContext = createContext<UsersManagementContextProps>({
  searchQuery: '',
  setSearchQuery: () => undefined,
  timeframeDrawerOpen: false,
  setTimeframeDrawerOpen: () => undefined,
  filters: {} as UserManagementFilters,
});

export function UsersManagementProvider({ children }: PropsWithChildren) {
  const [searchParams] = useSearchParams();

  const [searchQuery, setSearchQuery] = useState('');
  const filters: UserManagementFilters = decodeSearchParams(searchParams);

  const [timeframeDrawerOpen, setTimeframeDrawerOpen] = useState(false);

  const contextValues = useMemo(
    () => ({
      searchQuery,
      setSearchQuery,
      timeframeDrawerOpen,
      setTimeframeDrawerOpen,
      filters,
    }),
    [filters, searchQuery, timeframeDrawerOpen],
  );

  return (
    <UsersManagementContext.Provider value={contextValues}>
      {children}
    </UsersManagementContext.Provider>
  );
}

export const useUsersManagement = () => useContext(UsersManagementContext);
